/* Kits (Easy Bundles app) — presentation fixes, rendered from snippets/kbf-access.liquid.
   1. Prices: Easy Bundles writes RON as "L296" / "L207.20". This rewrites them as "296 lei" / "207,20 lei"
      (Romanian: 1.387,40 lei · English: 1,387.40 lei · French: 1 387,40 lei), only inside Easy Bundles
      elements (class "gbb…") and in the kit's properties in the cart.
   2. Cart: the kit line shows "Retail Price: L530 / You Save: L159 (30%) / Box: 1". The labels follow the kits brief
      ("Cumpărate separat … economisești"), the prices are reformatted and "Box" is hidden.
   3. Trio pages (/apps/gbb/easybundle/trio-…): a page heading above the builder ("Trio Ulei de baie și corp 100 ml"
      + one line on how 2+1 works), the page <title>, and the html class "kbf-eb-trio" used by assets/kbf-pdp.css.
      The app renders the builder without any heading; the texts below are the theme's (RO/EN/FR, 3 Nov).
   4. Kit pages (/apps/gbb/easybundle/<kit>, 4 Nov): the same heading as the trio pages — eyebrow "Ofertă Black Friday ·
      30% la fiecare kit", the kit name and its line from /pages/black-friday — with Ronald's "-30% kits" sticker, the
      gift ladder banner above it, and the html class "kbf-eb-kit" (assets/kbf-pdp.css hides the search, as on trios).
   Points 1–2 run only when the active currency is RON. Changes text only; prices and discounts come from the app. */
(function () {
  if (window.KBF_EB) return;
  window.KBF_EB = true;

  var lang = (document.documentElement.getAttribute('lang') || 'ro').slice(0, 2).toLowerCase();

  /* ---------- 3. trio page heading ---------- */
  var TRIO = {
    'trio-bath-body-oil-100-ml':     { ro: ['Trio Ulei de baie și corp 100 ml', 'uleiuri de baie și corp de 100 ml'], en: ['Trio Bath & Body Oil 100 ml', '100 ml bath & body oils'], fr: ['Trio Huile bain et corps 100 ml', 'huiles bain et corps de 100 ml'] },
    'trio-bath-body-oil-30-ml':      { ro: ['Trio Ulei de baie și corp 30 ml', 'uleiuri de baie și corp de 30 ml'], en: ['Trio Bath & Body Oil 30 ml', '30 ml bath & body oils'], fr: ['Trio Huile bain et corps 30 ml', 'huiles bain et corps de 30 ml'] },
    'trio-aromatic-roll-on-10-ml':   { ro: ['Trio Roll-on aromatic 10 ml', 'roll-on-uri aromatice de 10 ml'], en: ['Trio Aromatic Roll-On 10 ml', '10 ml aromatic roll-ons'], fr: ['Trio Roll-on aromatique 10 ml', 'roll-on aromatiques de 10 ml'] },
    'trio-body-oil-100-ml':          { ro: ['Trio Ulei de corp 100 ml', 'uleiuri de corp de 100 ml'], en: ['Trio Body Oil 100 ml', '100 ml body oils'], fr: ['Trio Huile pour le corps 100 ml', 'huiles pour le corps de 100 ml'] },
    'trio-body-wash-400-ml':         { ro: ['Trio Gel de duș 400 ml', 'geluri de duș de 400 ml'], en: ['Trio Body Wash 400 ml', '400 ml body washes'], fr: ['Trio Gel douche 400 ml', 'gels douche de 400 ml'] },
    'trio-hand-wash-500-ml':         { ro: ['Trio Săpun lichid pentru mâini 500 ml', 'săpunuri lichide pentru mâini de 500 ml'], en: ['Trio Hand Wash 500 ml', '500 ml hand washes'], fr: ['Trio Savon liquide pour les mains 500 ml', 'savons liquides pour les mains de 500 ml'] },
    'trio-massage-oil-400-ml':       { ro: ['Trio Ulei de masaj 400 ml', 'uleiuri de masaj de 400 ml'], en: ['Trio Massage Oil 400 ml', '400 ml massage oils'], fr: ['Trio Huile de massage 400 ml', 'huiles de massage de 400 ml'] },
    'trio-interior-perfume-290-ml':  { ro: ['Trio Parfum de interior 290 ml', 'parfumuri de interior de 290 ml'], en: ['Trio Interior Perfume 290 ml', '290 ml interior perfumes'], fr: ["Trio Parfum d'intérieur 290 ml", "parfums d'intérieur de 290 ml"] },
    'trio-fragrance-oil-10-ml':      { ro: ['Trio Ulei parfumat 10 ml', 'uleiuri parfumate de 10 ml'], en: ['Trio Fragrance Oil 10 ml', '10 ml fragrance oils'], fr: ['Trio Huile parfumée 10 ml', 'huiles parfumées de 10 ml'] },
    'trio-fragrance-oil-400-ml':     { ro: ['Trio Ulei parfumat 400 ml', 'uleiuri parfumate de 400 ml'], en: ['Trio Fragrance Oil 400 ml', '400 ml fragrance oils'], fr: ['Trio Huile parfumée 400 ml', 'huiles parfumées de 400 ml'] },
    'trio-petit-luxe-atomizer':      { ro: ['Trio Atomizor de esență Petit Luxe', 'atomizoare Petit Luxe'], en: ['Trio Petit Luxe Essence Atomiser', 'Petit Luxe atomisers'], fr: ['Trio Diffuseur Petit Luxe', 'diffuseurs Petit Luxe'], colours: true },
    'trio-commercial-luxe-atomizer': { ro: ['Trio Atomizor de esențe Commercial Luxe', 'atomizoare Commercial Luxe'], en: ['Trio Commercial Luxe Essence Atomiser', 'Commercial Luxe atomisers'], fr: ['Trio Diffuseur Commercial Luxe', 'diffuseurs Commercial Luxe'], colours: true }
  };
  var TRIO_TEXT = {
    ro: { eyebrow: 'Ofertă Black Friday · Cumpără 2, primești 1 gratuit', sub: 'Alege 3 {items}, în orice combinație de {mix}. Cel mai ieftin este gratuit.', scents: 'arome', colours: 'culori' },
    en: { eyebrow: 'Black Friday offer · Buy 2, get 1 free', sub: 'Pick 3 {items}, in any mix of {mix}. The cheapest one is free.', scents: 'scents', colours: 'colours' },
    fr: { eyebrow: 'Offre Black Friday · 2 achetés, 1 offert', sub: "Choisissez 3 {items}, dans n'importe quelle combinaison de {mix}. Le moins cher est offert.", scents: 'parfums', colours: 'couleurs' }
  };
  /* Kits: name + line as on /pages/black-friday (RO/EN from that page; FR are translations still to be approved) */
  var KITS = {
    'petit-rituel-1':   { name: 'Petit Rituel', ro: 'Trei produse, trei gesturi, zece minute care sunt doar ale tale.', en: 'Three products, three gestures, ten minutes that are yours.', fr: 'Trois produits, trois gestes, dix minutes rien qu’à vous.' },
    'rituel-du-bain':   { name: 'Rituel du Bain', ro: 'În Ayurveda, baia este un ritual, nu o rutină.', en: 'In Ayurveda, the bath is a rite, not a routine.', fr: 'En Ayurveda, le bain est un rite, pas une routine.' },
    'maison-classique': { name: 'Maison Classique', ro: 'Casa ta, amintită prin parfumul ei.', en: 'Your home, remembered by its scent.', fr: 'Votre maison, reconnue à son parfum.' },
    'maison-privee':    { name: 'Maison Privée', ro: 'Casa ta, amintită prin parfumul ei.', en: 'Your home, remembered by its scent.', fr: 'Votre maison, reconnue à son parfum.' },
    'grand-rituel':     { name: 'Grand Rituel', ro: 'Ritualul ayurvedic al fiecărei zile.', en: 'The Ayurvedic daily ritual.', fr: 'Le rituel ayurvédique de chaque jour.' }
  };
  var KIT_EYEBROW = { ro: 'Ofertă Black Friday · 30% la fiecare kit', en: 'Black Friday offer · 30% off every kit', fr: 'Offre Black Friday · 30 % sur chaque kit' };
  var pageMatch = window.location.pathname.match(/\/apps\/gbb\/easybundle\/([a-z0-9-]+)/);
  var trio = pageMatch && TRIO[pageMatch[1]];
  var kit = pageMatch && KITS[pageMatch[1]];
  if (trio) document.documentElement.classList.add('kbf-eb-trio');
  if (kit) document.documentElement.classList.add('kbf-eb-kit');

  function addHeading() {
    /* previous: if (!trio || document.querySelector('.kbf-eb-head')) return; */
    if ((!trio && !kit) || document.querySelector('.kbf-eb-head')) return;
    var builder = document.querySelector('.gbbFullPageBundle');
    if (!builder || !builder.parentNode) return;
    if (kit) { addKitHeading(builder); return; }
    var t = TRIO_TEXT[lang] || TRIO_TEXT.ro;
    var names = trio[lang] || trio.ro;
    var head = document.createElement('header');
    head.className = 'kbf-eb-head';
    var eyebrow = document.createElement('p'); eyebrow.className = 'kbf-eb-head__eyebrow'; eyebrow.textContent = t.eyebrow;
    var title = document.createElement('h1'); title.className = 'kbf-eb-head__title'; title.textContent = names[0];
    var sub = document.createElement('p'); sub.className = 'kbf-eb-head__sub';
    sub.textContent = t.sub.replace('{items}', names[1]).replace('{mix}', trio.colours ? t.colours : t.scents);
    head.appendChild(eyebrow); head.appendChild(title); head.appendChild(sub);
    builder.parentNode.insertBefore(head, builder);
    document.title = names[0] + ' · Kyphie';
    addGifts();
  }

  /* Gift ladder banner (same as on the collection pages) above the trio heading ("Black Friday offer · Buy 2, get 1 free").
     Rendered by snippets/kbf-access.liquid into <template id="kbf-trio-gifts"> on trio pages only.
     previous (4 Nov, first version): placed between the heading and the builder. */
  /* 4. kit heading: eyebrow, kit name, line, and the "-30% kits" sticker (<template id="kbf-kit-sticker">, kbf-access) */
  /* 4 Nov, client: "the kit page starts with the kit information, then they scroll down and select the items".
     The kit card (<template id="kbf-kit-info">, snippets/kbf-kit-info.liquid) goes first, then the gift banner, then the
     builder; the short heading below stays as the fallback when the template is missing.
     The note "choose N products" above the "Continuă" box is CSS only (assets/kbf-pdp.css, --kbf-kit-note), so nothing
     is inserted inside the app's own markup. */
  var KIT_COUNT = { 'petit-rituel-1': 3, 'rituel-du-bain': 4, 'maison-classique': 5, 'maison-privee': 5, 'grand-rituel': 13 };
  var KIT_NOTE = {
    ro: 'Ca să completezi kitul, alege {n} produse, urmând pașii de mai sus.',
    en: 'To complete your kit, choose {n} products, following the steps above.',
    fr: 'Pour compléter votre kit, choisissez {n} produits en suivant les étapes ci-dessus.'
  };
  /* + how many products are still to choose in the current step (Serban, 4 Nov). The step's requirement comes from its
     title ("3 uleiuri parfumate 10 ml" = 3, otherwise 1); the products chosen are the quantity steppers on the cards
     of the step on screen. Recomputed on every change of the builder (run() below). */
  var STEP_NOTE = {
    ro: { left: ' La pasul „{step}” mai ai de ales {k} {p}.', done: ' Pasul „{step}” e complet: treci la următorul.', one: 'produs', many: 'produse' },
    en: { left: ' At the “{step}” step, choose {k} more {p}.', done: ' The “{step}” step is complete: go on to the next one.', one: 'product', many: 'products' },
    fr: { left: ' À l’étape « {step} », choisissez encore {k} {p}.', done: ' L’étape « {step} » est complète : passez à la suivante.', one: 'produit', many: 'produits' }
  };
  var kitNoteBase = '', kitNoteLast = '';
  function updateKitNote() {
    if (!kitNoteBase) return;
    var text = kitNoteBase;
    var cur = document.querySelector('.gbbFullPageBundle [aria-current="step"] .gbbNavigationTitle');
    if (cur) {
      var step = cur.textContent.trim();
      var m = step.match(/^(\d+)\s/);
      var need = m ? parseInt(m[1], 10) : 1;
      var chosen = 0;
      document.querySelectorAll('.gbbFullPageBundle .gbbProductsContainer .gbbQuantityStepperLabel').forEach(function (l) { chosen += parseInt(l.textContent, 10) || 0; });
      var left = Math.max(need - chosen, 0);
      var t = STEP_NOTE[lang] || STEP_NOTE.en;
      text += (left > 0 ? t.left : t.done).replace('{step}', step).replace('{k}', left).replace('{p}', left === 1 ? t.one : t.many);
    }
    if (text === kitNoteLast) return;
    kitNoteLast = text;
    document.documentElement.style.setProperty('--kbf-kit-note', JSON.stringify(text));
  }
  function addKitHeading(builder) {
    var count = KIT_COUNT[pageMatch[1]];
    if (count) {
      kitNoteBase = (KIT_NOTE[lang] || KIT_NOTE.en).replace('{n}', count);
      updateKitNote();
      document.documentElement.classList.add('kbf-eb-kit-note');
    }
    var info = document.getElementById('kbf-kit-info');
    if (info && info.content && info.content.querySelector('.kbf-kitinfo')) {
      var wrap = document.createElement('div');
      wrap.className = 'kbf-eb-head kbf-eb-kitinfo';
      wrap.appendChild(info.content.cloneNode(true));
      builder.parentNode.insertBefore(wrap, builder);
      var mark = document.createElement('span');
      mark.id = 'kbf-kit-builder';
      mark.className = 'kbf-eb-anchor';
      builder.parentNode.insertBefore(mark, builder);
      document.title = kit.name + ' · Kyphie';
      addGifts();
      return;
    }
    var head = document.createElement('header');
    head.className = 'kbf-eb-head kbf-eb-head--kit';
    var text = document.createElement('div');
    var eyebrow = document.createElement('p'); eyebrow.className = 'kbf-eb-head__eyebrow'; eyebrow.textContent = KIT_EYEBROW[lang] || KIT_EYEBROW.ro;
    var title = document.createElement('h1'); title.className = 'kbf-eb-head__title'; title.textContent = kit.name;
    var sub = document.createElement('p'); sub.className = 'kbf-eb-head__sub'; sub.textContent = kit[lang] || kit.ro;
    text.appendChild(eyebrow); text.appendChild(title); text.appendChild(sub);
    head.appendChild(text);
    var sticker = document.getElementById('kbf-kit-sticker');
    if (sticker && sticker.content) head.appendChild(sticker.content.cloneNode(true));
    builder.parentNode.insertBefore(head, builder);
    document.title = kit.name + ' · Kyphie';
    addGifts();
  }

  function addGifts() {
    /* previous: if (!trio || document.querySelector('.kbf-eb-gifts')) return; */
    if ((!trio && !kit) || document.querySelector('.kbf-eb-gifts')) return;
    var tpl = document.getElementById('kbf-trio-gifts');
    /* kits with the kit card: the banner goes between the card and the builder */
    var anchor = document.querySelector('.kbf-eb-kitinfo') ? document.getElementById('kbf-kit-builder') : (document.querySelector('.kbf-eb-head') || document.querySelector('.gbbFullPageBundle'));
    if (!tpl || !tpl.content || !anchor || !anchor.parentNode) return;
    var wrap = document.createElement('div');
    wrap.className = 'kbf-eb-gifts';
    wrap.appendChild(tpl.content.cloneNode(true));
    anchor.parentNode.insertBefore(wrap, anchor);
  }

  var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'RON';
  if (currency !== 'RON') {
    /* Other currencies: no price rewriting, only the trio heading */
    var startHeading = function () {
      addHeading();
      new MutationObserver(function () { addHeading(); }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startHeading); else startHeading();
    return;
  }
  var TS = lang === 'en' ? ',' : (lang === 'fr' ? ' ' : '.');
  var DS = lang === 'en' ? '.' : ',';
  var LABELS = {
    ro: { 'Retail Price': 'Cumpărate separat', 'You Save': 'Economisești' },
    en: { 'Retail Price': 'Bought separately', 'You Save': 'You save' },
    fr: { 'Retail Price': 'Acheté séparément', 'You Save': 'Vous économisez' }
  }[lang] || {};
  var HIDDEN_PROPERTIES = ['Box'];

  /* "296" → 29600 · "207.20" → 20720 · "1,387.40" → 138740 · "1.387,40" → 138740 */
  function toCents(text) {
    var s = text.trim();
    var lastDot = s.lastIndexOf('.'), lastComma = s.lastIndexOf(',');
    var decimalAt = -1;
    if (lastDot > -1 && lastComma > -1) {
      decimalAt = Math.max(lastDot, lastComma);
    } else {
      var sep = Math.max(lastDot, lastComma);
      if (sep > -1 && s.length - sep - 1 <= 2) decimalAt = sep;
    }
    var whole = (decimalAt > -1 ? s.slice(0, decimalAt) : s).replace(/\D/g, '') || '0';
    var decimals = decimalAt > -1 ? (s.slice(decimalAt + 1).replace(/\D/g, '') + '00').slice(0, 2) : '00';
    return parseInt(whole, 10) * 100 + parseInt(decimals, 10);
  }

  function money(cents) {
    var whole = Math.floor(cents / 100), dec = cents % 100;
    var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, TS);
    if (dec > 0) out += DS + (dec < 10 ? '0' : '') + dec;
    return out + ' lei';
  }

  /* "L296", "L 207.20", "L1,387.40" — an "L" that is not part of a word, followed by a number */
  var PRICE = /(^|[^A-Za-zÀ-ž])L\s?(\d(?:[\d.,]*\d)?)/g;
  function fixPrices(text) {
    return text.replace(PRICE, function (match, before, number) { return before + money(toCents(number)); });
  }

  function fixTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) { return /L\s?\d/.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var fixed = fixPrices(node.nodeValue);
      if (fixed !== node.nodeValue) node.nodeValue = fixed;
    });
  }

  function fixCartProperty(li) {
    if (li.hasAttribute('data-kbf-eb')) return;
    var text = li.textContent;
    var colon = text.indexOf(':');
    if (colon < 0) return;
    var name = text.slice(0, colon).trim();
    if (HIDDEN_PROPERTIES.indexOf(name) > -1) { li.hidden = true; li.setAttribute('data-kbf-eb', ''); return; }
    if (!LABELS[name] && !/L\s?\d/.test(text)) return;
    var value = fixPrices(text.slice(colon + 1).trim());
    li.textContent = (LABELS[name] || name) + ': ' + value;
    li.setAttribute('data-kbf-eb', '');
  }

  function run(scope) {
    addHeading();
    updateKitNote();
    var root = scope && scope.querySelectorAll ? scope : document;
    var ebRoots = [];
    if (root.matches && root.matches('[class*="gbb"]')) ebRoots.push(root);
    root.querySelectorAll('[class*="gbbBundle"], [class*="gbbMix"], [class*="gbbFooter"], [class*="gbbProduct"], [class*="gbbPb"], [class*="gbbQb"]').forEach(function (el) {
      if (!el.parentElement || !el.parentElement.closest('[class*="gbb"]')) ebRoots.push(el);
    });
    ebRoots.forEach(fixTextNodes);
    root.querySelectorAll('.line-item__property').forEach(fixCartProperty);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; run(document); });
  }

  function start() {
    run(document);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length || mutations[i].type === 'characterData') { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
